var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "164px",
    height: "164px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-1.1121408711770158s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.692307692307693 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-1.0194624652455977s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.38461538461539 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.9267840593141797s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(83.07692307692308 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.8341056533827618s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110.76923076923077 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.7414272474513438s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(138.46153846153845 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.6487488415199258s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(166.15384615384616 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.5560704355885079s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(193.84615384615384 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.46339202965708987s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(221.53846153846155 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.3707136237256719s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(249.23076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.27803521779425394s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276.9230769230769 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.18535681186283595s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.61538461538464 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "-0.09267840593141798s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(332.3076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    rx: 0.88,
    ry: 0.88,
    width: 2,
    height: 11,
    fill: "#421e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.2048192771084336s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner0);
export default __webpack_public_path__ + "static/media/Spinner-0.5fe89333a1a5590e960592eeaeebe62e.svg";
export { ForwardRef as ReactComponent };